import { useContext } from 'react';
import { FrodorModulesContext } from '../../../Context';
export const useFooterLinks = ({ getTranslation, trackCat }) => {
    const { isFrodor } = useContext(FrodorModulesContext);
    const helpfulLinks = [
        {
            href: 'https://www.spotify.com/about-us/contact/',
            track: [trackCat, 'About'],
            dataTestId: 'footer-about',
            label: getTranslation('FRODOR_2b48af'),
            external: true,
        },
        {
            href: 'https://newsroom.spotify.com',
            track: [trackCat, 'Press & Media'],
            dataTestId: 'footer-press-and-media',
            label: getTranslation('FRODOR_f24f14'),
            external: true,
        },
        {
            href: 'https://artists.spotify.com/providers',
            track: [trackCat, 'Providers'],
            dataTestId: 'footer-providers',
            label: getTranslation('FRODOR_83327b'),
            external: true,
        },
        {
            href: isFrodor ? '/contact' : 'https://artists.spotify.com/contact',
            track: [trackCat, 'Contact Us'],
            dataTestId: 'footer-contact',
            label: getTranslation('FRODOR_51f8e4'),
            useInternalNavigation: isFrodor,
        },
    ];
    const creatorToolsLinks = [
        {
            href: 'https://www.soundtrap.com/?utm_source=spotify_site&utm_medium=footer_menulink&utm_campaign=alwayson_global_soundtrap_destination',
            track: [trackCat, 'Creator Tools - Soundtrap'],
            dataTestId: 'footer-soundtrap',
            label: 'Soundtrap',
            external: true,
        },
        {
            href: 'https://podcasters.spotify.com/?utm_source=artists.spotify.com',
            track: [trackCat, 'Creator Tools - Spotify for Podcasters'],
            dataTestId: 'footer-s4p',
            label: 'Spotify for Podcasters',
            external: true,
        },
        {
            href: 'https://noteable.spotify.com/?utm_source=artists.spotify.com',
            track: [trackCat, 'Creator Tools - Noteable'],
            dataTestId: 'footer-spa',
            label: 'Noteable',
            external: true,
        },
    ];
    const policiesLinks = [
        {
            label: getTranslation('FRODOR_LEGAL_LINK_TEXT_FOOTER'),
            href: 'https://www.spotify.com/legal/spotify-for-artists-terms-and-conditions/',
            dataTestId: 'footer-legal',
            track: [trackCat, 'Legal'],
            external: true,
        },
        {
            label: getTranslation('FRODOR_PRIVACY_LINK_TEXT_FOOTER'),
            href: 'https://www.spotify.com/legal/privacy-policy/',
            dataTestId: 'footer-privacy',
            track: [trackCat, 'Privacy Policy'],
            external: true,
        },
        {
            label: getTranslation('FRODOR_COOKIES_LINK_TEXT_FOOTER'),
            href: 'https://www.spotify.com/legal/cookies-policy/',
            dataTestId: 'footer-cookies',
            track: [trackCat, 'Cookies'],
            external: true,
        },
    ];
    const footerLinks = {
        helpfulLinks,
        creatorTools: creatorToolsLinks,
        policies: policiesLinks,
    };
    return footerLinks;
};
//# sourceMappingURL=useFooterLinks.js.map